import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";

import { RootState } from "./types";
import auth from "./modules/auth";
import profile from "./modules/profile";
import event from "./modules/event";
import survey from "./modules/survey";
import shards from "./modules/shards";
import notifications from "./modules/notifications";
import device from "./modules/device";
import resources from "./modules/resources";
import statistics from './modules/statistics';
import testing from './modules/testing';
import app from './modules/app'
import dialog from './modules/dialog'
import locale from './modules/locale'
import events from './modules/events'
import push from './modules/push'
import alerts from './modules/alerts'
import country from './modules/country'
import organizers from './modules/organizers'
import forms from './modules/forms'
import news from '@/store/modules/news';
import chapter from '@/store/modules/chapter';
import advent from '@/store/modules/advent';
import company from '@/store/modules/company';
import standmans from '@/store/modules/standmans';
import programs from '@/store/modules/programs';
import new_statistic from "@/store/modules/new_statistic";

Vue.use(Vuex);

export const store: StoreOptions<RootState> = {
  modules: {
    advent,
    push,
    chapter,
    news,
    forms,
    organizers,
    country,
    alerts,
    events,
    locale,
    auth,
    profile,
    event,
    shards,
    survey,
    notifications,
    device,
    resources,
    statistics,
    testing,
    app,
    dialog,
    company,
    standmans,
    programs,
    new_statistic
  },
};

export default new Vuex.Store<RootState>(store);
